import { eliteAccionesRoles } from '../../acciones-roles/reportes/elite-admin-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const EliteAdminRoutes: SideBarButton = {
  data: {
    name: 'Elite Admin - Power BI',
    roles: eliteAccionesRoles.sideNavActions.root,
    appendUrl: './reportsPBI/elite-admin',
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Horas extras',
        url: '/overtime',
        roles: eliteAccionesRoles.sideNavActions.extraHours,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Quality Control',
        url: '/quality-control',
        roles: eliteAccionesRoles.sideNavActions.qualityControl,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Inspections',
        url: '/inspections',
      },
      options: PreConfigButton3,
    },
  ],
};
